module.exports = __webpack_public_path__ + "media/images/logo-where-blue-19b9922b29c6e6f6c78fe2a45272832a.svg";